import type { OrganisationAgent } from '../api/types'
import { displayName } from '../room/format'

/** Waiting on you first, then the live ones, then the rest. */
function rank(agent: OrganisationAgent): number {
  return agent.waiting > 0 ? 0 : agent.online ? 1 : 2
}

/** Your agents whose newest session is in the room, ranked, each rank in the stream's order. */
export function agentsIn(agents: readonly OrganisationAgent[], channelId: string | undefined): OrganisationAgent[] {
  return agents
    .filter((agent) => agent.channel_id === channelId)
    .sort((first, second) => rank(first) - rank(second))
}

type Named = Pick<OrganisationAgent, 'name' | 'nickname'>

/** What a row calls an agent: its nickname, or the part of its handle after the last `/`. */
export function shortName(agent: Named): string {
  return displayName(agent.name.slice(agent.name.lastIndexOf('/') + 1), agent.nickname)
}

/** What a screen reader calls that row: the nickname, then the handle it is tagged by, said once. */
export function spokenName(agent: Named): string {
  return agent.nickname ? `${agent.nickname} ${agent.name}` : agent.name
}
